window.app = (function ($) {

    "use strict";

    var transitions = {

        startDuration:500,

        default: {
            before: function () {
                // close menu
            },
            startDuration: 500, // css smoothstate transition speed + menu speed when closing
            start: function ($container) {
                var _this = this;
                //hide search autocomplet dropdown
                if($(".algolia-autocomplete").length) {
                    $(".algolia-autocomplete").hide();
                    $(".current_page_parent").removeClass("current_page_parent");
                }
                // transition in

                $('#smoothstate_transition').fadeIn(transition_speed);

                var duration = _this.duration; // startDuration

                // once overlay is displayed
                setTimeout(function () {
                    // $('#smoothstate_transition').find('.cadigal-loader').addClass('animate');
                    onPageDestroy();
                }, duration)

            },
            readyDuration: 500,
            ready: function ($container, $newContent) {
                $('html, body').scrollTop(0);

                $(window).unbind('resize');
                $(window).unbind('scroll');

                $container.html($newContent);

                onPageReady();
            },
            after: function () {
                this.destroyPreviousPage();
                this.loadCurrentPage();

                // trigger google analytics on page load
                if (window.ga) {
                    ga('set', 'page', document.location.pathname); // need to ensure this is sending the correct path
                    ga('send', 'pageview');
                }

                if(window.fbq) {
                    fbq('track', 'PageView');
                }

                // pardot tracking code
                // if(window.piTracker) {
                // 	// console.log('pitracker yes');
                // 	piTracker(document.location.pathname); //http://help.pardot.com/customer/portal/articles/2133697-advanced-topic-using-tracking-code-within-javascript-mvc-frameworks
                // } else {
                // 	// console.log('pitracker no');
                // }

                // transition out
                var tl = new TimelineMax({
                    onStart: function () {
                        // make sure at top of page
                        $('html, body').scrollTop(0);
                    },
                    onComplete: function () {
                        // make sure logo is hidden
                        //$('#smoothstate_transition .logo').css('opacity','0');
                        // scroll to anchor if needed
                        var url = window.location.href;
                        if ( url.indexOf('#') > 0) {
                            var hash = url.substring(url.indexOf("#")+1);
                            if ( hash.length > 0 ) {
                                $('html,body').stop().animate({
                                    scrollTop: $("#"+hash).offset().top},
                                0);
                            }
                        }
                    }
                });
                // $('#smoothstate_transition').find('.cadigal-loader').removeClass('animate');
                $('#smoothstate_transition').fadeOut(transition_speed);

                pageAnimation.init();
            },
        },

        custom: {

        }

    };

    // use different page transition
    var transitionForAnchor = function (anchor) {

        if (anchor === null)
            return;

        var anchor_class = anchor.attr('data-anchor');

        if (typeof transitions[anchor_class] !== "undefined") {
            return transitions[anchor_class];
        }

        return transitions.default;
    };


    // Runs on every page once ready
    var onPageReady = function (firstLoad) {

        firstLoad = firstLoad || false;

        // if (animate) {
        //     pageAnimation.init();
        // }
        // first time page loaded, animation done after loader screen gone.
        if ( !firstLoad ) {
            animations.init();
        }

        // IE
        if(!window.getComputedStyle(document.body).mixBlendMode) {
            $('html').addClass('no-mix-blend-mode');
        }
        if(!window.getComputedStyle(document.body).backgroundBlendMode) {
            $('html').addClass('no-background-blend-mode');
        }

        $('#menu-primary').find('.menu-item.no-smoothstate').each(function(){
            $(this).find('a').addClass('no-smoothstate');
        });

        /// When home banner iframe is loaded.
        var homeVideoIframe = $("#wp-body-div.home #popup_video_container").find('iframe');
        homeVideoIframe.on('load', function(){
            videoHomePopup.iframeLoaded = true;
        });

        // update row colors...
        if ( $('.stacker-section').length > 0 ) {
            $('.stacker-section').each(function() {
                var firstRow = $(this).find('.vc_row').first();
                if (firstRow.hasClass('grey')) {
                    $(this).addClass('grey');
                }
            });
        }


        // on mobile open listing cards in same window
        updateListingCardLinkTarget();
        $(window).smartresize(function(){
            updateListingCardLinkTarget();
        })
        function updateListingCardLinkTarget() {
            if ( $('html').hasClass('touch') || Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
                $('.listing-grid .item a').each(function(){
                    $(this).attr('target','');
                })
            } else {
                $('.listing-grid .item a').each(function(){
                    $(this).attr('target','_blank');
                })
            }
        }

        // Cookie for UTM Parameters
    	function getParameterByName(name) {
    	    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    	    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    	    var results = regex.exec(location.search);
    	    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    	}

    	var utmSource = getParameterByName('utm_source');
    	var utmMedium = getParameterByName('utm_medium');
    	var utmCampaign = getParameterByName('utm_campaign');
    	var utmContent = getParameterByName('utm_content');
    	var utmTerm = getParameterByName('utm_term');

        // Set the cookies
        if(utmSource && ($.cookie('utm_source') == null || $.cookie('utm_source') == "")) {
            $.cookie('utm_source', utmSource, { path: '/' });
        }
        if(utmMedium && ($.cookie('utm_medium') == null || $.cookie('utm_medium') == "")) {
            $.cookie('utm_medium', utmMedium, { path: '/' });
        }
        if(utmCampaign && ($.cookie('utm_campaign') == null || $.cookie('utm_campaign') == "")) {
            $.cookie('utm_campaign', utmCampaign, { path: '/' });
        }
        if(utmContent && ($.cookie('utm_content') == null || $.cookie('utm_content') == "")) {
            $.cookie('utm_content', utmContent, { path: '/' });
        }
        if(utmTerm && ($.cookie('utm_term') == null || $.cookie('utm_term') == "")) {
            $.cookie('utm_term', utmTerm, { path: '/' });
        }

        // Svg
        svg4everybody();

        lazyload.init();

        // init components
        formatCmsComponents();

        initTestimonials();
        initFeaturedProjectsSliders();
        initLogoSliders();

        // Agent Sliders
        initAgentSliders();
        initAgentNavbarSliders();
        initAgentPopupSliders();

        // Galleries
        initListingSliders();
        initContentSliders();
        // initGalleries();

        // Videos
        // videoPopup.init();
        initEmbedVideos();
        loopingVideo.init(); // bg video

        //===== SoHubs
        // if ( $(".sohubs-section").length ) {
            // sohubs.init();
        // }
        forms.initContactEnquiryForm();
        forms.initLeadGenForm();
        forms.initDownloadForm();
        forms.initSubscriptionForm();
        forms.initProductProjectEnquiryForm();
        forms.initStartAProjectForm();
        forms.initStartAProjectFormCard();


        forms.initCallNowForm();

        mobileMenu.init();

        navbar.init();
        stackerNav.init();

        // mobile collapsable sections
        collapsable.init();

        searchMap.initItemSlider($("#pls-product-cards").find('.item'));
        searchMap.initItemSlider($("#team_related_project_list").find('.item'));

        if ( $( ".spaces-load-more" ).length ) {
            project.init();
            $( ".spaces-load-more" ).trigger( "click" );
        }

        $('[data-toggle="tooltip"]').tooltip();
        if ( $( ".has-datepicker" ).length ) {
            $('.has-datepicker').datepicker({
              dateFormat: "dd/mm/yy"
            });
        }

        // #anchor Smoothscroll
        $('a.smoothscroll').off('click').on('click', function(e){
          e.preventDefault();
          var top = $(this.hash).offset().top;
          $('body,html').stop().animate({
                'scrollTop': top
                }, 600);
        })

        //add "no-smoothstate" class to search pagination links
        if($(".navigation .nav-links .page-numbers").length) {
            $(".navigation .nav-links .page-numbers").addClass('no-smoothstate');
        }

        $(document).click(function(e){
            if($(e.target).closest('.search-keyword-input').length != 0) return false;
            if($(e.target).closest('.algolia-autocomplete').length != 0) return false;
            $('.algolia-autocomplete').hide();
        });

        // hide number (if no js enabled, full number displays)
        // $('.reveal-number').find('.last').text('**** ****');

        // $('.reveal-number').off().on('click', function (e) {
        //     if ($(this).hasClass('is-min')) {
        //         e.preventDefault();
        //         $(this).find('.last').text($(this).data('last'));
        //         $(this).removeClass('is-min');
        //     }
        // })
        $('.reveal-number').off().on('click', function (e) {
            if ($(this).hasClass('is-min')) {
                e.preventDefault();

                var tel = $(this).data('number');

                // google analytics event
                if (window.ga) {
                    ga('send', {
                      hitType: 'event',
                      eventCategory: 'Agent Reveal Number',
                      eventAction: 'click',
                      eventLabel: tel
                    });
                }

                $(this).find('.text').text(tel);
                $(this).removeClass('is-min');
            }
        })


        // Reveal social on touch devices
        if ( $('html').hasClass('touch') ) {
            $('.reveal-social').on('click', function() {
                $(this).toggleClass('hover');
            })
        }



        // === Forms
        // toggle focus on parent (where border is)
        $('.form-control').bind('focus blur', function () {
            $(this).closest('.form-group').toggleClass('focus');
        });
        // toggle filled
        $('.form-control').on('change', function () {
            if (this.value) {
                $(this).closest('.form-group').addClass('filled');
            } else {
                $(this).closest('.form-group').removeClass('filled');
            }
        });

        // ===== Parsley
        var parsleyOptions = {
            // add error class on form group instead of default form control
            classHandler: function (el) {
                return el.$element.closest(".form-group");
            },
            errorsContainer: function (pEle) {
                var $err = pEle.$element.parents('.form-group');
                // var $err = pEle.$element.parents('.parsley-validate').find('.parsley-errors');
                return $err;
            }
        }

        if ($('.parsley-validate').length) {
            $('.parsley-validate').parsley(parsleyOptions);
        }

        if($(".view-hidden-text").length > 0) {
            $('.read_more_container p:empty').remove();
        }

        // window.Parsley.on('form:error', function() {
        //   var errorsContainer = this.$element.find('.parsley-errors');
        //   // errorsContainer.prepend('<p>Following errors found:</p>')

        // });

        shortlist.initShortlist(parsleyOptions);
        forms.initSitePopupForm(parsleyOptions);

        if ( !firstLoad ) {
            forms.displaySitePopup();
        }

        // === Custom Selects

        $(".custom-select").each(function() {

            var theme_class = "";

            if ( $(this).hasClass('light') ) {
                theme_class += ' light';
            }

            if ( $(this).hasClass('coworking') ) {
                theme_class += ' coworking';
            }
            if ( $(this).hasClass('small-text') ) {
                theme_class += ' small-text';
            }

            $(this).selectmenu({
                classes: {
                    "ui-selectmenu-button": theme_class,
                    "ui-selectmenu-menu": theme_class
                },
                change: function( event, data ) {
                    // update "filled" class
                    if ( this.value ) {
                        $(this).closest('.form-group').addClass('filled');
                    } else {
                        $(this).closest('.form-group').removeClass('filled');
                    }

                    // update validation
                    var formGroup = $(this).parents('.form-group');
                    var form = $(this).closest('form');
                    if ( formGroup.hasClass('parsley-error') ) {
                        form.parsley(parsleyOptions).validate();

                    }

                    // Filter news article
                    if ( $(this).parents('.news_filter_form').length > 0 ) {
                        if(nfIsLoading) return;

                        // scroll to section
                        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
                            var scrollOffset = $('#header').height(); // header height
                        } else {
                            var scrollOffset = 150; // space above filters
                        }
                        $('body,html').stop().animate({
                            'scrollTop': $('.news-listing-section').offset().top - scrollOffset
                        }, 200);


                        nfIsLoading = true;
                        var form = $(this).parents('.news_filter_form');
                        var formData = form.serialize() + '&action=process_news_filter';

                        var deferred_request = $.ajax({
                            method: "POST",
                            url: admin_ajax_url,
                            data: formData,
                            datatype: "JSON"
                        });

                        deferred_request.done(function( data ) {
                            data = $.parseJSON(data);

                            nfIsLoading = false;

                            $(".news-listing").html(data.content);
                            if(data.more_data === 1) {
                                //$('.news-listing').html(data.content);
                                nfMoreData = true;
                                nfPage = nfPage + 1;
                                $(".insights-load-more").removeClass('is-hidden');
                                //$('.insights-load-more').show();
                            } else {
                                //$('.news-listing').html(data.content);
                                nfMoreData = false;
                                $(".insights-load-more").addClass('is-hidden');
                                //$('.insights-load-more').hide();
                            }
                            nfIsLoading = false;
                            nfPage = 1;
                        });

                        deferred_request.fail(function( data ) {
                            nfIsLoading = false;
                            console.log('Failed AJAX Call :( /// Return Data: ' + data);
                        });
                    }
                }
            })
        });

        //readmore
        // view more button
        $(".view-hidden-text").click(function () {

            var area = $(this).parents(".liquid-content-container").find(".hidden-text");
            var viewLess = $(this).parents(".liquid-content-container").find(".hide-hidden-text");
            $(this).css({opacity: 0, visibility: "visible"}).animate({opacity: 0}, 200);
            $(this).insertAfter(viewLess);
            setTimeout(function () {
                viewLess.fadeIn(100);
            }, 150)

            area.slideDown(400);

            //offset += 50;

            // window scroll
            // $('body,html').stop().animate(
            //   {'scrollTop':area.offset().top - offset},
            //   scroll_duration
            // );

            return false;
        });
        // view less button
        $(".hide-hidden-text").click(function (e) {
                e.preventDefault();

                var area = $(this).parents(".liquid-content-container").find(".hidden-text");
                var viewMore = $(this).parents(".liquid-content-container").find(".view-hidden-text");
                $(this).css('display', 'none');
                setTimeout(function () {
                                viewMore.css({opacity: 1, visibility: "visible"}).animate({opacity: 1}, 200);
                    //viewMore.fadeIn(100);
                }, 300)

                //offset += 100;

                // window scroll
                // $('body,html').stop().animate(
                //   {'scrollTop':viewMore.offset().top - offset},
                //   scroll_duration
                // );
                // // scrolling up: top menu wont show
                // $('body').addClass('scrolling-to-section');
                // setTimeout(function(){
                //   $('body').removeClass('scrolling-to-section');
                // }, scroll_duration+50 );

                area.slideUp(400);

                return false;

         });

        //project search
        searchMap.init();
        amenitiesMap.init();


        // ==== Video Component
        // <iframe class="embed-responsive-item" src="'.$lq_embed_video_url.'"></iframe>

        // $('.video-section .video-placeholder-img').click(function () {
        //     var video = '<iframe class="embed-responsive-item" src="' + $(this).attr('data-video-src') + '"></iframe>';
        //     // $(this).replaceWith(video);
        //     $(video).insertAfter($(this));
        //     $(this).fadeOut();
        // });

    };


    // Runs on every page before showing new page (on Smoothstate start)
    var onPageDestroy = function () {

        if ( $( ".has-datepicker" ).length ) {
            $( ".has-datepicker" ).datepicker( "destroy" );
        }



        $('body').removeClass('modal-open');

        animations.destroy();

        searchMap.destroy();
        amenitiesMap.destroy();

        // destroy components
        destroyTestimonials();
        destroyFeaturedProjectsSliders();
        destroyLogoSliders();

        // agent sliders
        destroyAgentSliders();
        destroyAgentNavbarSliders();
        destroyAgentPopupSliders();

        destroyGalleries();

        // Videos
        // videoPopup.destroy();
        destroyEmbedVideos();
        loopingVideo.destroy(); // bg video

        navbar.destroy();
        stackerNav.destroy();

        mobileMenu.destroy();


        forms.destroyContactEnquiryForm();
        forms.destroyLeadGenForm();
        forms.destroyDownloadForm();
        forms.destroySubscriptionForm();
        forms.destroyProductProjectEnquiryForm();
        forms.destroyStartAProjectForm();
        forms.destroySitePopupForm();
        forms.destroyCallNowForm();

        shortlist.destroyShortlist();
        sohubs.destroy();

        // mobile collapsable sections
        collapsable.destroy();
    };


    // Runs on window smart resize
    var onWindowResize = function () {
    };


    var app_state = {
        current_anchor: null,
        project_new_div: null,
    };

    // ======= SMOOTHSTATE CONF
    var smoothstate_conf = {
        prefetch: true,
        cacheLength: 10,
        debug: false,
        blacklist: '.no-smoothstate',
        onBefore: function ($anchor, $container) {
            app_state.current_anchor = $anchor;
            var transitions = transitionForAnchor(app_state.current_anchor);
            transitions.before.call(this, $anchor, $container);
        },
        onStart: {
            duration: 500,
            render: function ($container) {
                var transitions = transitionForAnchor(app_state.current_anchor);
                this.duration = transitions.startDuration;
                transitions.start.call(this, $container);
            }
        },
        onReady: {
            duration: 500,
            render: function ($container, $newContent) {
                var transitions = transitionForAnchor(app_state.current_anchor);
                this.duration = transitions.readyDuration;
                transitions.ready.call(this, $container, $newContent);
            },
        },
        // onAfter: see app.smoothstateAfter
    };

    // ======= APP
    var app = {

        smoothState: null,
        container: "",
        page_key_history: [],

        transition_duration: 500,

        init: function (container) {

            this.container = container;

            var that = this;

            smoothstate_conf.onAfter = function () {
                that.smoothstateAfter.call(that);

                // TODO: confirm with Prem if this is the best/only way (Liquid)
                var postId = $('#wp-body-div').attr('data-post-id');
                var postType = $('#wp-body-div').attr('data-post-type') ? $('#wp-body-div').attr('data-post-type') : 'Page';
                var adminEditLink = $('#wp-admin-bar-edit a');
                if(postId) {
                    adminEditLink.attr('href', function(index, self){
                        return self.replace(/(post=)[1-9]+/, '$1' + postId);
                    });
                }
                adminEditLink.text('Edit ' + postType.charAt(0).toUpperCase() + postType.slice(1));
            };

            // instantiate smoothstate
            this.smoothState = $(this.container).smoothState(smoothstate_conf);


            // PRELOADER

            // Fade out loader after x seconds or when window is fully loaded.
            // Note: Loader animates for 1s (via css) so set time to 1 for it to play once...
            var windowLoaded = false,
                counter = 0,
                time = 1; // minimum seconds the preloader should display for

            // wait for window to be loaded before fading out screen loader.
            // $(window).load(function() {
            //     windowLoaded = true;
            // });

            $("#screen_preloader").find('.cadigal-loader').addClass('animate');

            // Home video
            var isHomePage = $('#main').attr('data-page-key') === ('home');
            // check is video had loaded
            // if ( isHomePage ) {
            //     var homeVideo = document.querySelector('#background_video');
            //     if ( $(homeVideo).length > 0 ) {
            //         var videoLoaded = false;
            //         homeVideo.oncanplaythrough = function(){
            //             videoLoaded = true;
            //         };
            //     }
            // }

            var interval = setInterval(function () {

                counter++;

                // wait 1 sec before fading out screen loader
                if ( counter > 1 ) { windowLoaded = true; }

                if ( isHomePage ) {
                    // if ( counter > time && windowLoaded && videoLoaded ) {
                    if ( counter > time && windowLoaded ) {
                        $(window).scrollTop(0);
                        $("#screen_preloader").find('.cadigal-loader').removeClass('animate');
                        $("#screen_preloader").fadeOut('400',function(){
                            // if home: keep overflow hidden (will be removed when animation complete)

                            // remove overlflow hidden
                            $('body').removeClass('screen-preloader-on');

                            pageAnimation.animateHome();
                            animations.init();
                            // pageAnimation.init();
                        });
                        clearInterval(interval);
                    }
                } else if ( counter > time && windowLoaded ) {
                    $("#screen_preloader").find('.cadigal-loader').removeClass('animate');
                    $("#screen_preloader").fadeOut('400',function(){

                        // $('body').css('overflow','initial');
                        $('body').removeClass('screen-preloader-on');

                        // start setTimeout for site popup display
                        forms.displaySitePopup();

                        pageAnimation.init();
                        animations.init();
                    });
                    clearInterval(interval);
                }

            }, 1000);

            $(window).load(function() {
                windowLoaded = true;
            });

            onPageReady(true);
            this.loadCurrentPage();
        },

        pageByKey: function (key) {
            return typeof this.pages[key] === "undefined"
                    ? false
                    : this.pages[key];
        },

        initPage: function (page) {

            if (typeof page.init === "function") {
                page.init();
            }
        },

        destroyPage: function (page) {

            if (typeof page.destroy === "function") {
                page.destroy();
            }
        },

        smoothstateAfter: function () {

            var transitions = transitionForAnchor(app_state.current_anchor);
            transitions.after.call(this);
        },

        destroyPreviousPage: function () {

            var previous_page;

            if (this.page_key_history.length) {

                previous_page = this.pageByKey(this.page_key_history[this.page_key_history.length - 1]);

                if (previous_page) {
                    this.destroyPage(previous_page);
                }
            }
        },

        loadCurrentPage: function () {

            var new_page_key = $("#main").attr("data-page-key");

            this.page_key_history.push(new_page_key);

            var new_page = this.pageByKey(new_page_key);
            this.initPage(new_page);
        },

        loadUrl: function (url) {
            $('<a class="hidden" href="' + url + '"></a>').appendTo(this.container).trigger("click");
            // no need to remove because this.container is replaced with new content ;)
        },

        pages: {
            home: {
                resizeBanner: function() {
                    if ( $('.home-hero-banner').length > 0 ) {
                        var viewportHeight = $('.home-hero-banner').outerHeight();
                        $('.home-hero-banner').css({ height: viewportHeight });
                    }
                },
                init: function () {
                    var _this = this;
                    // resize banner
                    // _this.resizeBanner();
                    // $(window).smartresize(function () {
                    //     _this.resizeBanner();
                    // })


                    // === BANNER VIDEO
                    videoBanner.init();
                    videoHomePopup.init();

                    initHomeStatementSliders();


                },
                destroy: function () {
                    videoBanner.destroy();
                    videoHomePopup.destroy();

                    destroyHomeStatementSliders();
                }
            },
            freeform: {
                init: function () {
                },
                destroy: function () {
                }
            },
            projects: {
                init: function () {
                },
                destroy: function () {
                }
            },
            project: {
                init: function () {
                    initListingHeroSliders();
                    agentModal.init();
                },
                destroy: function () {
                    destroyListingHeroSliders();
                    agentModal.destroy();
                }
            },
            product: {
                updateSidebarPosition: function(el) {

                    // dont resize if no gallery
                    if ( $('#main').hasClass('no-gallery') ) { el.removeClass('loading'); return; }

                    if (Modernizr.mq("screen and (min-width:" + bp_wrapper_width + "px)")) {
                        var sidebarTopOffset = el.offset().top;
                        var slideBottomOffset = $('#product_hero_slider').offset().top + $('#product_hero_slider').height();
                        var topOffset = -(sidebarTopOffset - slideBottomOffset + 90);

                    } else {
                        var topOffset = '';
                    }

                    var mt = el.css('marginTop').replace(/[^-\d\.]/g, '');
                    var marginTop = parseInt(mt)+parseInt(topOffset);

                    el.css('marginTop', marginTop);
                    // el.css('top', topOffset);
                    el.removeClass('loading');
                },
                init: function () {
                    // product_hero_slider
                    var _this = this;

                    initListingHeroSliders();

                    if ($('.listing-sidebar').length > 0) {

                        var sidebar = $('.listing-sidebar');

                        _this.updateSidebarPosition(sidebar);

                        $(window).smartresize(function () {
                            sidebar.addClass('loading');
                            _this.updateSidebarPosition(sidebar);
                        })
                    }

                    agentModal.init();
                },
                destroy: function () {
                    destroyListingHeroSliders();
                    agentModal.destroy();
                }
            },
            news: {
                resizeEl: function (el) {
                    if (Modernizr.mq("screen and (min-width:" + bp_wrapper_width + "px)")) {
                        var leftOffset = el.parent().find('.insights-section').offset().left;
                    } else {
                        var leftOffset = '';
                    }

                    el.css('margin-left', leftOffset);
                    el.removeClass('loading');
                },
                handleScroll: function(e) {
                    e.preventDefault();
                    var _this = e.data.obj;
                    if (_this.loading ) { return; }

                    // load more when "load more" button is in view
                    if($(window).scrollTop() + $(window).innerHeight() > $('.insights-load-more').offset().top  ) {
                        _this.loading = true;
                        $('.insights-load-more').click();
                    }
                },
                init: function () {
                    var _this = this;

                    if ($('.news-filters-container').length > 0) {

                        var filters = $('.news-filters-container');

                        _this.resizeEl(filters);

                        $(window).smartresize(function () {
                            filters.addClass('loading');
                            _this.resizeEl(filters);
                        })
                    }

                    // Load more on scroll
                    $(window).on('scroll', {obj: _this}, _this.handleScroll); // passing _this to method

                    nfMoreData = true;
                    // var nfIsLoading = false; // in helpers.js
                    $(document).on('click', '.insights-load-more', function() {


                        //console.log('load more clicked');
                        if(nfIsLoading || !nfMoreData) {
                            return;
                        }
                        nfIsLoading = true;

                        var btn = $(this);

                        btn.addClass('loading');

                        // $(".news-listing").append("<div class='spinner-load-more'><div class='spinner'></div><p class='mb0'>Load more</p></div>");
                        var form = $(".news_filter_form");
                        var formData = form.serialize() + '&action=process_news_filter&page=' + nfPage +'&loadmore=yes';

                        var deferred_request = $.ajax({
                            method: "POST",
                            url: admin_ajax_url,
                            data: formData,
                            datatype: "JSON"
                        });

                        deferred_request.done(function( data ) {
                            data = $.parseJSON(data);

                            if (data.count + data.offset >= data.total_count ) {
                                btn.addClass('is-hidden');
                            } else {
                                btn.removeClass('is-hidden');
                            }

                            $(".news-listing").append(data.content);
                            if(data.more_data === 1) {
                                //$(".news-listing").append(data.content);
                                nfMoreData = true;
                                nfPage = nfPage + 1;
                                btn.removeClass('is-hidden');
                                // btn.removeClass('is-hidden');
                                // $('.insights-load-more').show();
                            } else {
                                nfMoreData = false;
                                btn.addClass('is-hidden');
                                // btn.addClass('is-hidden');
                                // $('.insights-load-more').hide();
                            }

                            nfIsLoading = false;
                            // $(".news-listing .spinner-load-more").remove();
                        });

                        deferred_request.fail(function( data ) {
                            nfIsLoading = false;
                            console.log('Failed AJAX Call :( /// Return Data: ' + data);
                            // $(".news-listing .spinner-load-more").remove();
                        });

                        deferred_request.always(function() {
                            btn.removeClass('loading');
                            _this.loading = false;

                        });
                    });



                    // done in with custon select code
                    // $(document).on('change', '.filter_news', function() {
                    //     if(nfIsLoading) return;

                    //     nfIsLoading = true;
                    //     var form = $(".news_filter_form");
                    //     var formData = form.serialize() + '&action=process_news_filter';

                    //     var deferred_request = $.ajax({
                    //         method: "POST",
                    //         url: admin_ajax_url,
                    //         data: formData,
                    //         datatype: "JSON"
                    //     });

                    //     deferred_request.done(function( data ) {
                    //         data = $.parseJSON(data);
                    //         if(data.more_data === 1) {
                    //             $('.news-listing').html(data.content);
                    //             nfMoreData = true;
                    //             $('.insights-load-more').show();
                    //         } else {
                    //             $('.news-listing').html(data.content);
                    //             nfMoreData = false;
                    //             $('.insights-load-more').hide();
                    //         }
                    //         nfIsLoading = false;
                    //         nfPage = 1;
                    //     });

                    //     deferred_request.fail(function( data ) {
                    //         nfIsLoading = false;
                    //         console.log('Failed AJAX Call :( /// Return Data: ' + data);
                    //     });
                    // });


                },
                destroy: function () {
                    var _this = this;
                    $(document).off('click', '.insights-load-more');
                    // $(document).off('change', '.filter_news');
                    $(window).off('scroll', _this.handleScroll);
                }
            },
            casestudies: {
                init: function () {
                    var _this = this;

                    nfMoreData = true;
                    // var nfIsLoading = false; // in helpers.js
                    $(document).on('click', '.insights-load-more', function() {

                        //console.log('load more clicked');
                        if(nfIsLoading || !nfMoreData) {
                            return;
                        }
                        nfIsLoading = true;

                        var btn = $(this);

                        btn.addClass('loading');

                        // $(".news-listing").append("<div class='spinner-load-more'><div class='spinner'></div><p class='mb0'>Load more</p></div>");
                        var form = $(".news_filter_form");
                        var formData = form.serialize() + '&action=process_casestudies_filter&page=' + nfPage +'&loadmore=yes';

                        var deferred_request = $.ajax({
                            method: "POST",
                            url: admin_ajax_url,
                            data: formData,
                            datatype: "JSON"
                        });

                        deferred_request.done(function( data ) {
                            data = $.parseJSON(data);

                            if (data.count + data.offset >= data.total_count ) {
                                btn.addClass('is-hidden');
                            } else {
                                btn.removeClass('is-hidden');
                            }

                            $(".news-listing").append(data.content);
                            if(data.more_data === 1) {
                                //$(".news-listing").append(data.content);
                                nfMoreData = true;
                                nfPage = nfPage + 1;
                                btn.removeClass('is-hidden');
                                // btn.removeClass('is-hidden');
                                // $('.insights-load-more').show();
                            } else {
                                nfMoreData = false;
                                btn.addClass('is-hidden');
                                // btn.addClass('is-hidden');
                                // $('.insights-load-more').hide();
                            }

                            nfIsLoading = false;
                            // $(".news-listing .spinner-load-more").remove();
                        });

                        deferred_request.fail(function( data ) {
                            nfIsLoading = false;
                            console.log('Failed AJAX Call :( /// Return Data: ' + data);
                            // $(".news-listing .spinner-load-more").remove();
                        });

                        deferred_request.always(function() {
                            btn.removeClass('loading');

                        });
                    });


                },
                destroy: function () {
                    $(document).off('click', '.insights-load-more');
                    // $(document).off('change', '.filter_news');
                }
            },
            news_post: {
                resizeBanner: function (banner) {
                    if (Modernizr.mq("screen and (min-width:" + bp_wrapper_width + "px)")) {
                        var leftOffset = banner.parent().find('.author-details').offset().left;
                        var width = 'calc(100% - '+leftOffset+'px)';
                    } else {
                        var leftOffset = '';
                        var width = '';
                    }

                    banner.css('left', leftOffset);
                    banner.css('width', width);
                    banner.removeClass('loading');
                },
                init: function () {
                    var _this = this;


                    // === Banner Image

                    if ($('.news-featured-img').length > 0) {

                        var banner = $('.news-featured-img');

                        _this.resizeBanner(banner);

                        $(window).smartresize(function () {
                            banner.addClass('loading');
                            _this.resizeBanner(banner);
                        })
                    }

                },
                destroy: function () {
                }
            },
            team: {
                paginationEl: '.team-pagination-item',
                paginationCenter: '',
                paginationOffset: '',
                paginationOffsetStop: '',
                resizeBanner: function (banner) {
                    if (Modernizr.mq("screen and (min-width:" + bp_wrapper_width + "px)")) {
                        // var leftOffset = banner.parent().find('.banner-content').offset().left;
                        var leftOffset = $('#page_banner .banner-content').offset().left;
                    } else {
                        var leftOffset = '';
                    }

                    banner.css('left', leftOffset);
                    banner.removeClass('loading');
                },
                updatePagination: function(e) {
                    // if in scroll event, "this" is given as param
                    var _this = e == null ? this : e.data.obj;

                    // === Update Position

                    // fixed once in middle of page
                    var a = $(window).scrollTop() + _this.paginationCenter > _this.paginationOffset;
                    var b = $(window).scrollTop() <= _this.paginationOffsetStop
                    if ( a && b ) {
                        _this.el.removeClass('bottom').addClass('fixed');
                        _this.el.addClass('on'); // fade in
                        _this.el.css('top','50%');
                    }
                    // if footer is in view
                    else if ($(window).scrollTop() > _this.paginationOffsetStop ) {
                        _this.el.addClass('on'); // fade out
                        // if content is long, center pagination in page (vertically)
                        var top = _this.paginationOffsetStop - _this.el.height()/2 + _this.negativeMargin - _this.paginationOffset + $(window).height()/2;

                        // if content is short, position pagination as per on page load
                        if (  $('#page_content').outerHeight() + $('#page_banner').outerHeight(true) + _this.negativeMargin <= $(window).height() ) {
                            var top = _this.negativeMargin;
                        }

                        _this.el.removeClass('fixed').addClass('bottom');
                        _this.el.css('top', top);

                    } else {
                        _this.el.removeClass('on'); // fade out
                        // if top of page, unfix pagination
                        _this.el.removeClass('fixed');
                        _this.el.removeClass('bottom');
                        _this.el.css('top', _this.negativeMargin);
                    }
                },
                init: function () {
                    var _this = this;


                    // === Featured Image
                    if ($('.team-featured-img').length > 0) {

                        var banner = $('.team-featured-img');

                        _this.resizeBanner(banner);

                        $(window).smartresize(function () {
                            banner.addClass('loading');
                            _this.resizeBanner(banner);
                        })
                    }


                    // === Fixed Pagination
                    if ( $(_this.paginationEl).length < 1 ) return;

                    _this.el = $(_this.paginationEl);

                    _this.paginationOffset = _this.el.offset().top;

                    var anchorStop = $('.footer-signup-section') ? $('.footer-signup-section') : $('#footer');

                    _this.paginationOffsetStop = anchorStop.offset().top - $(window).height(); // footer top
                    _this.paginationCenter = $(window).height()/2 - _this.el.height() / 2; // same as el offset

                    // _this.negativeMargin = - parseInt($('#page_banner').css('margin-bottom'));
                    _this.negativeMargin = 0;


                    // no pagination on small laptop
                    if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)") ) {
                        $(window).on('scroll', {obj: _this}, _this.updatePagination);
                    }

                    // on resize, reset or destroy
                    $(window).smartresize(function(){

                        if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)") ) {
                            // no pagination on small laptop
                            $(window).off('scroll', _this.updatePagination );
                        } else {
                            // reset
                            _this.el.removeClass('fixed').removeClass('bottom');
                            _this.el.css({'top':_this.negativeMargin, 'bottom':'auto'});
                            _this.paginationOffset = _this.el.offset().top;
                            _this.paginationOffsetStop = $('#main_footer').offset().top - $(window).height(); // footer top
                            _this.paginationCenter = $(window).height()/2 - _this.el.height() / 2; // same as el offset
                            _this.negativeMargin = - parseInt($('#page_banner').css('margin-bottom'));
                            $(window).off('scroll', _this.updatePagination );
                            $(window).on('scroll', {obj: _this}, _this.updatePagination);
                        }

                    })

                },
                destroy: function () {
                    // === Fixed Pagination
                    var _this = this;
                    $(window).off('scroll', _this.updatePagination );
                }
            },
            start_project: {
                init: function () {

                    if ( $(".range-slider").length > 0 ) {
                        $(".range-slider").each(function(){
                            var rs = $(this);

                            var isSQM = $(this).attr('id') == 'budget_sqm_field';

                            // var isPa = $(data.input).attr('id') == 'budget_pa_field';
                            if (isSQM) {
                                var min = 600;
                                var max = 2000;
                                var step = 100;
                            } else {
                                var min = 20000;
                                var max = 4000000;
                                var step = 10000;
                            }

                            rs.ionRangeSlider({
                                type: "double",
                                force_edges: true,
                                min: min,
                                max: max,
                                from: min,
                                to: max,
                                prefix: "$",
                                max_postfix: "+",
                                step: step,
                                onStart: function (data) {
                                    rs.parents('.range-slider-container').removeClass('loading');
                                    // if ( $(data.input).attr('id') == 'budget_pa_field' ) {
                                    //     $('#pa_min').val(data.from);
                                    //     $('#pa_max').val(data.to);
                                    // } else {
                                    //     $('#sqm_pa_min').val(data.from);
                                    //     $('#sqm_pa_max').val(data.to);
                                    // }

                                    $('#pa_min').val(data.from);
                                    $('#pa_max').val(data.to);
                                    $('#sqm_pa_min').val('');
                                    $('#sqm_pa_max').val('');
                                },
                                onFinish: function(data) {
                                    var isPa = $(data.input).attr('id') == 'budget_pa_field';

                                    if (isPa) {
                                        $('#pa_min').val(data.from);
                                        $('#pa_max').val(data.to);
                                        $('#sqm_pa_min').val('');
                                        $('#sqm_pa_max').val('');
                                    } else {
                                        $('#pa_min').val('');
                                        $('#pa_max').val('');
                                        $('#sqm_pa_min').val(data.from);
                                        $('#sqm_pa_max').val(data.to);
                                    }
                                }
                            });
                        })
                    }


                    this.rangeSlider = $(".range-slider").data("ionRangeSlider");

                    // ===== Budget tabs
                    $('#budget-tabNav a').on('show.bs.tab', function (e) {

                        var ul = $(e.target).parents('li').parents('ul');
                        var line = ul.find('.line');

                        var i = $(e.target).parents('li').index();

                        // var id = $(this).attr('href');

                        // budget sqm
                        if ( i > 0 ) {
                            // move line
                            line.addClass('right');
                            // reset other slider
                            $('#budget-pa .range-slider').data("ionRangeSlider").reset();
                        }
                        // budget pa
                        else {
                            // move line
                            line.removeClass('right');
                            // reset other slider
                            $('#budget-sqm .range-slider').data("ionRangeSlider").reset();
                        }

                    })


                    // === Empty custom date if timing option is selected
                    if ( $('input[type=radio][name=timing_option]').length > 0 ) {
                        $('input[type=radio][name=timing_option]').on('change',function() {
                            if ( this.value != '' ) {
                                $('#liq_start_project_date_field').datepicker( "setDate", "" );
                            }
                        });
                    }

                    // === Unselect timing options if custom date
                    if ( $('#liq_start_project_date_field').length > 0 ) {
                        $('#liq_start_project_date_field').on('change',function() {
                            if ( this.value != '' ) {
                                $('input[type=radio][name=timing_option]').prop('checked', false);
                            }
                        });
                    }



                },
                destroy: function () {
                    if ( $(".range-slider").length > 0 ) {
                        $(".range-slider").each(function(){
                            var rs = $(this).data("ionRangeSlider");
                            if(rs) {
                                rs.destroy();
                            }
                        });
                    }
                }
            },
            contact: {
                init: function () {

                    // load images
                    $('#page_banner .img').css('width', $(document).width());
                    $('#page_banner .img').addClass('loaded');
                    $(window).smartresize(function(){
                        $('#page_banner .img').css('width', $(document).width());
                    })

                    // Split images
                    $('#page_banner .hotspot').hover(
                        function () {
                            if ($(this).hasClass('left')) {
                                $('#page_banner .banner-img.left').addClass('hover');
                                $('#page_banner .banner-content.right .banner-heading').addClass('off');

                                var banner = $('#page_banner .banner-img.left');
                                banner.css('z-index', 2);
                                $('#page_banner .banner-img.right').css('z-index', 1);
                                var tween = TweenMax.to(banner, .5, {width:"100%", ease:Sine.easeOut});

                            } else if ($(this).hasClass('right')) {
                                $('#page_banner .banner-img.right').addClass('hover');
                                $('#page_banner .banner-content.left .banner-heading').addClass('off');

                                var banner = $('#page_banner .banner-img.right');
                                banner.css('z-index', 2);
                                $('#page_banner .banner-img.left').css('z-index', 1);
                                var tween = TweenMax.to(banner, .5, {width:"100%", ease:Sine.easeOut});
                            }
                        },
                        function () {
                            if ($(this).hasClass('left')) {
                                $('#page_banner .banner-img.left').removeClass('hover');
                                $('#page_banner .banner-content.right .banner-heading').removeClass('off');

                                var banner = $('#page_banner .banner-img.left');
                                var tween = TweenMax.to(banner, .5, {width:"50%", ease:Sine.easeOut, onComplete:function(){
                                    banner.css('z-index', 1);
                                }});
                            } else if ($(this).hasClass('right')) {
                                $('#page_banner .banner-img.right').removeClass('hover');
                                $('#page_banner .banner-content.left .banner-heading').removeClass('off');

                                var banner = $('#page_banner .banner-img.right');
                                var tween = TweenMax.to(banner, .5, {width:"50%", ease:Sine.easeOut, onComplete:function(){
                                    banner.css('z-index', 1);
                                }});
                            }
                        }
                    );

                    $('#page_banner .hotspot').on('mouseenter mouseleave', function (e) {
                        $(this).toggleClass('hover');
                    })

                    // Fade in images
                    // $('#page_banner .hotspot').hover(
                    //         function () {
                    //             if ($(this).hasClass('left')) {
                    //                 $('#page_banner .banner-img.right').addClass('off');
                    //                 $('#page_banner .banner-content.right .banner-heading').addClass('off');
                    //                 $('#page_banner .banner-img.left').addClass('on');
                    //                 $('#page_banner .banner-content.left .banner-heading').addClass('on');
                    //             } else if ($(this).hasClass('right')) {
                    //                 $('#page_banner .banner-img.left').addClass('off');
                    //                 $('#page_banner .banner-content.left .banner-heading').addClass('off');
                    //                 $('#page_banner .banner-img.right').addClass('on');
                    //                 $('#page_banner .banner-content.right .banner-heading').addClass('on');
                    //             }
                    //         },
                    //         function () {
                    //             if ($(this).hasClass('left')) {
                    //                 $('#page_banner .banner-img.right').removeClass('off');
                    //                 $('#page_banner .banner-content.right .banner-heading').removeClass('off');
                    //                 $('#page_banner .banner-img.left').removeClass('on');
                    //                 $('#page_banner .banner-content.left .banner-heading').removeClass('on');
                    //             } else if ($(this).hasClass('right')) {
                    //                 $('#page_banner .banner-img.left').removeClass('off');
                    //                 $('#page_banner .banner-content.left .banner-heading').removeClass('off');
                    //                 $('#page_banner .banner-img.right').removeClass('on');
                    //                 $('#page_banner .banner-content.right .banner-heading').removeClass('on');

                    //             }
                    //         }
                    // );

                    // $('#page_banner .hotspot').on('mouseenter mouseleave', function (e) {
                    //     $(this).toggleClass('hover');
                    // })
                },
                destroy: function () {
                }
            }
        }
    };

    return app;

})(jQuery);


jQuery(document).ready(function () {
    // Init App
    window.app.init('#smoothstate_container');
});
